function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _uniqueId from 'lodash/uniqueId';
import { AdaptiveListener } from 'xps-react-utils';
import Navigation from './Navigation';
import NavItem from './NavItem';
import SubNav from './SubNav';
import SubNavGroup from './SubNavGroup';
import SubNavItem from './SubNavItem';

require('xps-style/core/navigation.css');

var propTypes = {
  links: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  theme: PropTypes.oneOf(['dark', 'light']),
  fullWidth: PropTypes.bool,
  contentComponent: PropTypes.func,
  location: PropTypes.object
};
var defaultProps = {
  theme: 'dark'
};

var navbarGenerator = function navbarGenerator(itemData) {
  var NavItemComponent = NavItem;
  var SubNavComponent = SubNav;
  var SubNavGroupComponent = SubNavGroup;
  var SubNavItemComponent = SubNavItem;
  var items = Array.isArray(itemData) === true ? itemData : itemData.props.children;
  return items.map(function (navItem) {
    return /*#__PURE__*/React.createElement(NavItemComponent, _extends({
      key: _uniqueId('nav-item_')
    }, navItem.props, {
      name: navItem.props.name,
      href: navItem.props.href
    }), navItem.props.children ? /*#__PURE__*/React.createElement(SubNavComponent, {
      key: _uniqueId('subnav_'),
      megamenu: navItem.props.megamenu,
      colWidth: navItem.props.colWidth,
      numOfCol: navItem.props.numOfCol
    }, React.Children.map(navItem.props.children, function (subNav) {
      if (subNav == null) {
        return false;
      }

      return subNav.props.children ? /*#__PURE__*/React.createElement(SubNavGroupComponent, _extends({
        key: _uniqueId('subnav-grp-item_')
      }, subNav.props, {
        name: subNav.props.name,
        href: subNav.props.href
      }), React.Children.map(subNav.props.children, function (subNavLink) {
        return /*#__PURE__*/React.createElement(SubNavItemComponent, _extends({
          key: _uniqueId('subnav-item_')
        }, subNavLink.props, {
          name: subNavLink.props.name,
          href: subNavLink.props.href
        }), subNavLink.props.name);
      })) : /*#__PURE__*/React.createElement(SubNavItemComponent, _extends({
        key: _uniqueId('subnav-item_')
      }, subNav.props, {
        name: subNav.props.name,
        href: subNav.props.href
      }), subNav.props.name);
    })) : null);
  });
};

var NavBar = /*#__PURE__*/function (_Component) {
  _inherits(NavBar, _Component);

  var _super = _createSuper(NavBar);

  function NavBar(props) {
    var _this;

    _classCallCheck(this, NavBar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onMobileSize", function () {
      return _this.updateSize('mobile');
    });

    _defineProperty(_assertThisInitialized(_this), "onTabletSize", function () {
      return _this.updateSize('tablet');
    });

    _defineProperty(_assertThisInitialized(_this), "onDesktopSize", function () {
      return _this.updateSize('desktop');
    });

    _defineProperty(_assertThisInitialized(_this), "updateSize", function (size) {
      if (_this.node) {
        _this.setState({
          size: size
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "AdaptiveNav", function () {
      var _this$props = _this.props,
          contentComponent = _this$props.contentComponent,
          links = _this$props.links,
          fullWidth = _this$props.fullWidth,
          theme = _this$props.theme,
          location = _this$props.location;
      var size = _this.state.size;

      if (size === 'mobile') {
        return null;
      } else {
        return /*#__PURE__*/React.createElement(Navigation, {
          ref: function ref(node) {
            _this.node = node;
          },
          theme: theme,
          fullWidth: fullWidth,
          contentComponent: contentComponent,
          location: location
        }, navbarGenerator(links));
      }
    });

    _this.state = {};
    _this.node = null;
    return _this;
  }

  _createClass(NavBar, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(AdaptiveListener, {
        onMobileSize: this.onMobileSize,
        onTabletSize: this.onTabletSize,
        onDesktopSize: this.onDesktopSize
      }, /*#__PURE__*/React.createElement(this.AdaptiveNav, null));
    }
  }]);

  return NavBar;
}(Component);

NavBar.propTypes = propTypes;
NavBar.defaultProps = defaultProps;
NavBar.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onMobileSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onTabletSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onDesktopSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "updateSize",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "size",
      "type": null
    }],
    "returns": null
  }, {
    "name": "AdaptiveNav",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "NavBar",
  "props": {
    "theme": {
      "defaultValue": {
        "value": "'dark'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'dark'",
          "computed": false
        }, {
          "value": "'light'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "links": {
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "array"
        }]
      },
      "required": false,
      "description": ""
    },
    "fullWidth": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "contentComponent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "location": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  }
};
export default NavBar;